var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.creatorVideo)?_c('div',[_c('b-btn',{staticClass:"action-button glass glass-smoke my-2",on:{"click":_vm.share}},[_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-share","size":"xl"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }